import React, { Component } from 'react';
import { Container } from 'react-bootstrap';

// Components
import ControlledCarousel from '../shared/controlled-carousel/controlled-carousel';
import ContactUs from '../contactus/contactus';
import ViewGalleryContainer from '../shared/view-gallery-container/view-gallery-container';
import { Footer } from '../shared/footer/footer';
import SectionLeftImage from '../shared/section-left-image/section-left-image';

class Home extends Component {
  render() {
    return (
      <Container fluid={true}>
        <ControlledCarousel />
        <SectionLeftImage title="What do we do in ABC Tree Service?" 
            content="ABC Tree Service offers you an extense variety of services for both residential and commercial properties.
            We can guarantee you that the job is done by professionals, we have the equipment, training and experience to get your job done right."/>
        <ViewGalleryContainer />
        <ContactUs />
        <Footer />
      </Container>
    );
  }
}

export default Home;
